import Events from './events';

export function notify(message = '') {
  const event = new Events.Notify(message);

  window.dispatchEvent(event);
}
